import React from 'react';
import { Button, Table, Loader, Modal } from 'semantic-ui-react';
import styled from 'styled-components';
import {
  useApiPortalV1EmployeeEmailEmailDeliveryStatusRetrieveQuery,
  useApiPortalV1EmployeeEmailMessageDeliveryStatusRetrieveQuery,
} from '../../store/generated/portal/employee/email';
import PositionedModal from './PositionedModal';
import { format } from 'date-fns';

const EmailDeliveryModal = (props: { email?: string | null; isOpen: boolean; onClose: () => void }) => {
  const { email, isOpen, onClose } = props;
  const [secondOpen, setSecondOpen] = React.useState(false);
  const [messageId, setMessageId] = React.useState('');

  const { data: emailDeliveryStatus, isLoading: isEmailLoading } = useApiPortalV1EmployeeEmailEmailDeliveryStatusRetrieveQuery(
    { email: email || '' },
    { skip: !email }
  );

  const { data: messageDeliveryStatus, isLoading: isMessageLoading } =
    useApiPortalV1EmployeeEmailMessageDeliveryStatusRetrieveQuery(
      { messageId: messageId || '' },
      { skip: !messageId }
    );

  function SelectedMessage(message_id: string) {
    setSecondOpen(true);
    setMessageId(message_id);
  }

  return (
    <>
      <PositionedModal open={isOpen} onClose={onClose} size="small">
        <Modal.Header>Recent emails sent to {email}</Modal.Header>
        <Modal.Content style={{ minWidth: 600, minHeight: 260 }}>
          {isEmailLoading ? (
            <div style={{ minHeight: 260, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
              <Loader active size="large">Loading emails...</Loader>

              {/* Skeleton table to keep modal size stable while fetching */}
              <div style={{ width: '100%', maxWidth: 560 }}>
                <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                  <div style={{ flex: 1, height: 18, background: '#f3f4f6', borderRadius: 4 }} />
                  <div style={{ flex: 2, height: 18, background: '#f3f4f6', borderRadius: 4 }} />
                  <div style={{ width: 140, height: 18, background: '#f3f4f6', borderRadius: 4 }} />
                </div>
                {[...Array(4)].map((_, i) => (
                  <div key={i} style={{ height: 36, background: '#f3f4f6', borderRadius: 6, marginBottom: 8 }} />
                ))}
              </div>
            </div>
          ) : emailDeliveryStatus && Array.isArray(emailDeliveryStatus.Messages) && emailDeliveryStatus.Messages.length > 0 ? (
            <Table celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Date</Table.HeaderCell>
                  <Table.HeaderCell>Subject</Table.HeaderCell>
                  <Table.HeaderCell>Delivery Details</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {emailDeliveryStatus?.Messages &&
                  emailDeliveryStatus.Messages.map((p, i) => (
                    <Table.Row key={i} active={messageId === p.MessageID}>
                      <Table.Cell>
                        {p?.ReceivedAt
                          ? format(new Date(p.ReceivedAt.toLocaleString()), 'EEEE, MMM do h:mm a')
                          : 'N/A'}
                      </Table.Cell>
                      <Table.Cell>{p?.Subject}</Table.Cell>
                      <Table.Cell>
                        <DeliveryInfoLabel onClick={() => SelectedMessage(p.MessageID ?? '')}>
                          Delivery Details
                        </DeliveryInfoLabel>
                      </Table.Cell>
                    </Table.Row>
                  ))}
              </Table.Body>
            </Table>
          ) : (
            <div style={{ minHeight: 260, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#666' }}>No emails have been recently sent</div>
          )}
        </Modal.Content>

        <Modal.Actions>
          <Button color="black" onClick={onClose}>
            Close
          </Button>
        </Modal.Actions>
      </PositionedModal>

      <PositionedModal open={secondOpen} onClose={() => setSecondOpen(false)} size="small">
        <Modal.Header>Delivery Details</Modal.Header>
        <Modal.Content style={{ minWidth: 520, minHeight: 180 }}>
          {isMessageLoading ? (
            <div style={{ minHeight: 180, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
              <Loader active size="large">Loading details...</Loader>
              <div style={{ width: '100%', maxWidth: 420 }}>
                {[...Array(3)].map((_, i) => (
                  <div key={i} style={{ height: 18, background: '#f3f4f6', borderRadius: 4, marginBottom: 8 }} />
                ))}
              </div>
            </div>
          ) : (
            <Table celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Date</Table.HeaderCell>
                  <Table.HeaderCell>Status</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {/* details populated from messageDeliveryStatus if available */}
              </Table.Body>
            </Table>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button icon="check" content="Close" onClick={() => setSecondOpen(false)} />
        </Modal.Actions>
      </PositionedModal>
    </>
  );
};

export default EmailDeliveryModal;

const DeliveryInfoLabel = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #555555;
  cursor: pointer;
  display: inline;
  padding: 0;
  margin: 0;
  line-height: 1.4;
  &:hover {
    color: #2a51c3;
  }
`;
